import { getRouter } from 'Router';
import { StackHandler, View } from 'StackHandler';
import { useIsDesktop } from 'hooks/useIsDesktop';
import { createContext, ReactNode, useMemo, useState } from 'react';
import { StackView } from '../components/StackView/StackView';

export const StackHandlerContext = createContext<StackHandler | null>(null);
export const StackStateContext = createContext<View[] | undefined>(undefined);

export const StackHandlerContextProvider = ({ children }: { children: ReactNode }) => {
  const [stack, setStack] = useState<View[]>([]);

  const handler = useMemo(
    () =>
      new StackHandler({
        onStackChange: setStack,
      }),
    [],
  );

  const isDesktop = useIsDesktop();

  const router = getRouter(isDesktop);

  router.subscribe((state) => {
    handler.clear();
  });

  return (
    <StackHandlerContext.Provider value={handler}>
      <StackStateContext.Provider value={stack}>
        {children}
        {stack.map((view, index) => (
          <StackView
            key={`${view.id}`}
            isOpen={true}
            onClose={() => handler.pop()}
            title={view.title}
            zIndex={80 + index}
          >
            {view.component}
          </StackView>
        ))}
      </StackStateContext.Provider>
    </StackHandlerContext.Provider>
  );
};
